export enum ReportTypeEnum {
  DAILY_HOURS = 'daily hours',
  TOTAL_HOURS = 'total hours',
}

export enum TimecardStatusEnum {
  CLOCKED_IN = 'clocked in',
  CLOCKED_OUT = 'clocked out',
}
